import ky from 'ky';
import { authService } from 'services';

export const withAuthorizationHeader = (headers = {}) => ({
  ...headers,
  Authorization: `Bearer ${authService.getToken()}`,
});

export default ky.create({ prefixUrl: `${process.env.REACT_APP_API_URL}/api` });
